import React from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import SimpleTable from "components/UI/DataTable/SimpleTable";
import ShowLayout from "layouts/ShowLayout";
import { CircularProgress } from "components/UI/Progress";


const styles = theme => ({
  root: {
    flexGrow: 1,
  },
  label: {
    color: "gray",
  },
});

class CustomersShow extends React.PureComponent {
  handleDiscard = () => {
    this.props.history.goBack();
  };

  render() {
    const { classes, customer, isLoading } = this.props;

    if (isLoading) return <CircularProgress />;

    return (
      <div className={classes.root}>
        <ShowLayout moduleName={"customers"}>
          <Grid container spacing={24}>
            <Grid item xs={12} sm={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Customer:
              </Typography>
              <Typography variant="h6" gutterBottom>
                {customer.name}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Region:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {customer.regionName}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6} />

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Email:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {customer.email}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Phone:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {customer.phone}
              </Typography>
            </Grid>

            <Grid item xs={12} sm={12}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Equipments:
              </Typography>
              <SimpleTable
                headers={equimentTableHeaders}
                rows={customer.equipments}
                moduleName="customers"
              />
            </Grid>

            <Grid item xs={12} sm={6}>
              <Typography
                variant="subtitle2"
                gutterBottom
                className={classes.label}
              >
                Notes:
              </Typography>
              <Typography variant="body1" gutterBottom>
                {customer.notes}
              </Typography>
            </Grid>
          </Grid>
        </ShowLayout>
      </div>
    );
  }
}

const equimentTableHeaders = [
  { alias: "Equipment", key: "name" },
  { alias: "Agreement", key: "agreementType" },
  { alias: "Installation Date", key: "installationDate" },
];

CustomersShow.defaultProps = {
  isEditing: false,
};

export default withStyles(styles)(CustomersShow);
